import { useQuery } from 'react-query';
import { sdk } from '../../../../API/TT_ELD/mobile/sdk';

export const useSDK = (type: 'MCU' | 'BLE', page: number, perPage: string, is_active: boolean) => {
  return useQuery(
    ['dashcam-sdk', type, page, perPage, is_active],
    () => sdk.readSDK(type, page, perPage, is_active),
    {
      refetchOnWindowFocus: false,
    },
  );
};
